<template>
  <div v-if="show" class="app-modal" role="presentation">
    <div class="app-modal__backdrop" @click="emitClose"></div>

    <section
      class="app-modal__dialog sale-customers-add-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sale-customers-add-modal-title"
      @click.stop
    >
      <header class="app-modal__header">
        <div>
          <h3 id="sale-customers-add-modal-title">{{ text.detail.customersTab.addModal.title }}</h3>
          <p>{{ text.detail.customersTab.addModal.subtitle }}</p>
        </div>
        <button
          class="app-modal__close"
          type="button"
          :aria-label="text.detail.customersTab.addModal.closeAriaLabel"
          @click="emitClose"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </header>

      <div class="app-modal__content sale-customers-add-modal__content">
        <form class="app-modal__form" @submit.prevent="emitSubmit">
          <section class="app-modal__section">

            <SaleModalMultiCustomerField
              :form="form"
              :v$="null"
            />
          </section>

          <footer class="app-modal__footer">
            <div class="app-modal__footer-right">
              <button type="button" class="btn btn-light" :disabled="submitting" @click="emitClose">
                {{ text.detail.customersTab.addModal.actions.cancel }}
              </button>
              <button type="submit" class="btn btn-primary" :disabled="submitting || selectedCustomerIds.length === 0">
                {{ submitting ? text.detail.customersTab.addModal.actions.submitting : text.detail.customersTab.addModal.actions.submit }}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import SaleModalMultiCustomerField from '@/components/salesMultiCustomer/modal/SaleMultiCustomerModalSections/SaleModalMultiCustomerField.vue';
import { useDomainText } from '@/composables/text/useDomainText';
import { toPositiveOptionId } from '@/utils/optionValues';

const { catalog: text } = useDomainText('sales');

const createInitialForm = () => ({
  customer: null,
  customers: [null],
});

export default {
  name: 'SaleCustomersAddModal',
  components: {
    SaleModalMultiCustomerField,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      text,
      form: createInitialForm(),
    };
  },
  computed: {
    selectedCustomerIds() {
      const options = Array.isArray(this.form?.customers) ? this.form.customers : [];
      const ids = options
        .map((option) => toPositiveOptionId(option))
        .filter((id) => id > 0);

      return Array.from(new Set(ids));
    },
  },
  watch: {
    show(visible) {
      if (visible) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.form = createInitialForm();
    },
    emitClose() {
      if (this.submitting) {
        return;
      }

      this.$emit('close');
    },
    emitSubmit() {
      if (this.submitting || this.selectedCustomerIds.length === 0) {
        return;
      }

      this.$emit('submit', {
        customer_ids: this.selectedCustomerIds,
        customers: this.selectedCustomerIds,
      });
    },
  },
};
</script>

<style scoped>
.sale-customers-add-modal__dialog {
  max-width: 680px;
  height: auto;
  max-height: calc(100vh - 48px);
}

.sale-customers-add-modal__content {
  min-height: 360px;
}

.sale-customers-add-modal__content .app-modal__form {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}

.sale-customers-add-modal__content .app-modal__section {
  flex: 1 1 auto;
}

.sale-customers-add-modal__content .app-modal__footer {
  margin-top: auto;
}
</style>
